// extracted by mini-css-extract-plugin
export var section = "about-module--section--3SLUY";
export var sectionContent = "about-module--sectionContent--3IXQ2";
export var videosWrapper = "about-module--videosWrapper--gg2S4";
export var videoCard = "about-module--videoCard--2t_Bb";
export var contentWrapper = "about-module--contentWrapper--1tCLV";
export var aboutCard = "about-module--aboutCard--18AUt";
export var illustration = "about-module--illustration--2f1NQ";